export default __webpack_public_path__ + "static/media/Thesis.4784319d.pdf";